import { ArrowRight } from 'lucide-react';
import { archeIconUrl } from '@/lib/arche-icon-url';

interface ArcheResultCardProps {
  arche: {
    archId: string;
    name: string;
    simpleDescription: string;
    imageRef: string | null;
  };
  onClick: () => void;
}

export function ArcheResultCard({ arche, onClick }: ArcheResultCardProps) {
  return (
    <button
      onClick={onClick}
      className="w-full p-4 rounded-xl bg-card border border-border hover:border-primary/50 hover:bg-accent/50 transition-all text-left group"
    >
      <div className="flex items-start gap-3">
        {arche.imageRef ? (
          <img
            src={archeIconUrl(arche.imageRef, 128) ?? ''}
            alt={arche.name}
            className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
          />
        ) : (
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <span className="text-xl font-semibold text-primary">{arche.name.charAt(0)}</span>
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-medium text-foreground truncate">{arche.name}</h3>
            <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
          </div>
          <p className="text-sm text-muted-foreground line-clamp-2 mt-1">
            {arche.simpleDescription}
          </p>
        </div>
      </div>
    </button>
  );
}
